/* src/app/shared/message/message.component.css */
.messageField {
  padding: 5px;
  position: fixed;
  left: 25%;
  bottom: 0;
  width: 50%;
  background-color: black;
  color: white;
  font-style: italic;
  text-align: center;
  z-index: 3;
}
@media (max-width: 767px) {
  .messageField {
    width: 90%;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}
/*# sourceMappingURL=message.component.css.map */
